import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getSettings } from "@/lib/api";
import { Seo } from "@/components/site/Seo";
import { PageIntro, Prose } from "@/components/site/PageIntro";

const BLOCKS = [
  { h: "History", p: [
    "Founded in India, Acharya Holdings was established as a permanent platform for building and stewarding long-term businesses. It began not as a single company, but as a discipline — a conviction that durable value is created through execution, governance, and continuity.",
    "Rather than pursue rapid experimentation, the organisation was structured for deliberate construction: strong foundations first, then the patience to let each venture mature on its own terms.",
  ]},
  { h: "Vision", p: [
    "To operate as an enduring institutional house under which independent ventures are created, governed, and supported across decades — each solving a meaningful real-world problem.",
  ]},
  { h: "Mission", p: [
    "To provide continuity, governance, and disciplined capital to a portfolio of operating companies, while preserving the independence each brand needs to execute with excellence.",
  ]},
  { h: "Values", p: [
    "Long-term thinking over short-term noise. Responsible growth over speculative scale. Institutional trust earned through transparency and consistent standards.",
  ]},
  { h: "Approach", p: [
    "We maintain consolidated oversight of financial controls, compliance, risk, and strategic direction, while avoiding unnecessary centralisation that limits agility at the operating level.",
    "This balance allows the group to function as a stabilising layer — preserving intent and institutional knowledge, independent of individual projects or market cycles.",
  ]},
  { h: "Future", p: [
    "The architecture is intentionally future-ready. As ventures mature, the platform can extend into investor relations, reporting, corporate responsibility, and beyond — without compromising the independence or focus of any operating company.",
  ]},
];

export default function About() {
  const { data: settings } = useQuery({ queryKey: ["settings"], queryFn: getSettings });
  return (
    <>
      <Seo title="About" path="/about" settings={settings} description="The history, vision, mission, values, and long-term approach of Acharya Holdings." />
      <PageIntro eyebrow="About" title="An institution built for continuity."
        description="Acharya Holdings provides shared oversight across governance, capital discipline, risk management, and long-term planning — while allowing individual brands the autonomy required to execute effectively." />
      <div className="surface-cream">
        <section className="container-inst py-16 lg:py-24">
          <Prose blocks={BLOCKS} />
        </section>
      </div>
    </>
  );
}
